import { Flexbox, Typography } from '@hiiretail/synergy-ui';
import { EmptyDataComponent } from './EmptyData.types';

export const EmptyData: EmptyDataComponent = ({ searchSubject }) => (
  <Flexbox container item flex="1 1 auto" alignItems="center" justifyContent="center">
    <Typography variant="body2">No {searchSubject} found.</Typography>
  </Flexbox>
);
